<div id="managePopUp" *ngIf="showTransactionsModalPopup">

  <div class="modal-header">
    <div class="modal-title">{{authoringContentData?.manageLine?.businessInternetPopupHeader}} </div>
    <button type="button" class="close" aria-label="Close" (click)="onCloseClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div>
          <p>{{authoringContentData?.manageLine?.businessInternetPopupBody}}</p>
        </div>
        <div>
          <p>{{authoringContentData?.manageLine?.businessInternetMsg}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="managePopUp" *ngIf="showSpectrumModelPopup">

  <div class="modal-header">
    <div class="modal-title">{{authoringContentData?.manageLine?.spectrumPopupHeader}} </div>
    <button type="button" class="close" aria-label="Close" (click)="onCloseClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div>
          <p>{{authoringContentData?.manageLine?.spectrumPopupBody}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="managePopUp" *ngIf="showBIChangePlanModelPopup">

  <div class="modal-header">
    <div class="modal-title">{{authoringContentData?.manageLine?.businessInternetChangePlanErrorHeader}} </div>
  </div>

  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div>
          <p>{{authoringContentData?.manageLine?.businessInternetChangePlanErrorBody}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-end">
    <button (click)="onCloseClick()" type="button" class="btn primary_btn"> Close
    </button>
  </div>
</div>